import "./BotStarterQuestions.css";

const BotStarterQuestions = () => {
  return (
    <div className="docs-starter-questions-container">
      <h1 className="docs-starter-questions-title">Bot Starter Questions</h1>

      <p className="docs-starter-questions-description">
        Starter questions are predefined prompts shown upfront to your users as gentle <strong>nudges</strong>. They help guide users into engaging with your chatbot quickly and naturally.
      </p>

      <p className="docs-starter-questions-description">
        You can customize and style the answers to these starter questions using <em>markdown</em>, allowing you to add formatting, links, and other rich text elements for better user experience.
      </p>

      <h2 className="docs-starter-questions-subtitle">Key Actions</h2>

      <ul className="docs-starter-questions-actions">
        <li>
          <strong>Add New Starter Question:</strong> Create and add custom starter questions to encourage users to start conversations.
        </li>
        <li>
          <strong>Discard Changes:</strong> Revert any unsaved modifications to your starter questions.
        </li>
        <li>
          <strong>Save Changes:</strong> Apply and save all your updates to starter questions.
        </li>
      </ul>
    </div>
  );
};

export default BotStarterQuestions;
